module.exports = __webpack_public_path__ + "img/androidProjectWhite.bffa4f27.svg";